<div class="modal active coverageOptions">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Impact Calculation</h2>
      <div class="close" (click)="cancelCoverage()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block" style="max-height: 500px; overflow-y: scroll">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label>Calculation Name</label>
                  <input name="calculationName" type="text" required alphaNumeric forbiddenSubstring="{{forbiddenSubstringName}}"
                       #calculationName="ngModel"  [(ngModel)]="impactAssessment.name"/>
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenSubstringName}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Mode</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input #singleLevelInput type="checkbox" (change)="singleLevel(singleLevelInput.checked)">
                  <label>Use Single Level</label>
                </div>

                <div *ngIf="singleLevelInput.checked">
                  <label>Altitude</label>
                  <div class="coordenates">
                    <input #singleLevelAltitudeFeet="ngModel" name="singleLevelAltitudeFeet" type="number" style="width: 30%" required
                           min="100 " max="60000"
                           [(ngModel)]="impactAssessment.minAltitude.feets"/>
                    <span>[ft]</span>

                    <input name="singleLevelAltitudeMeters" type="number" style="width: 30%"
                           min="30.48 " max="18288"
                           [(ngModel)]="impactAssessment.minAltitude.meters"/>
                    <span>[m]</span>
                  </div>
                  <span class="error" *ngIf="singleLevelAltitudeFeet.invalid">
                      The single level altitude value should be between 100 and 60000 ft or 30.48 and 18288 m.
                  </span>
                </div >
              </div>
            </div>
            <fieldset class="fields__block__section" [disabled]="singleLevelInput.checked">
              <div class="title">
                <h4>Alt. Range Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label>Max Altitude</label>
                  <div class="coordenates">
                    <input #maxAltitudeAltitudeFeet="ngModel" name="maxAltitudeAltitudeFeet" type="number"  style="width: 30%" required
                           min="0" max="60000"
                           [(ngModel)]="impactAssessment.maxAltitude.feets"/>
                    <span>[ft]</span>
                    <input name="maxAltitudeAltitudeMeters" type="number" style="width: 30%"
                           min="0" max="18288"
                           [(ngModel)]="impactAssessment.maxAltitude.meters"/>
                    <span>[m]</span>
                  </div>
                  <span class="error" *ngIf="maxAltitudeAltitudeFeet.invalid">
                    The Max Altitude level value should be between 0 and 60000 ft or 0 and 18288 m.
                  </span>
                </div>
                <div>
                  <label>Min Altitude</label>
                  <div class="coordenates">
                    <input #minAltitudeFeet="ngModel" name="minAltitudeFeet" type="number" style="width: 30%" required
                           min="0" max="60000"
                           [(ngModel)]="impactAssessment.minAltitude.feets"/>
                    <span>[ft]</span>
                    <input name="minAltitudeMeters" type="number" style="width: 30%"
                           min="0" max="18288"
                           [(ngModel)]="impactAssessment.minAltitude.meters"/>
                    <span>[m]</span>
                  </div>
                  <span class="error" *ngIf="minAltitudeFeet.invalid">
                      The Min Altitude level value should be between 0 and 60000 ft or 0 and 18288 m.
                  </span>
                  <span class="error"
                        *ngIf="impactAssessment.maxAltitude.feets-impactAssessment.minAltitude.feets < 0">
                      The Min Altitude value should be smaller than Max Altitude value.
                  </span>
                </div>
                <div>
                  <label>Altitude Increment</label>
                  <div class="coordenates">
                    <input #altitudeIncrementFeet="ngModel" name="altitudeIncrementFeet" type="number" style="width: 30%" required
                           [min]="singleLevelInput.checked ? 0 : 100 " max="60000"
                           [(ngModel)]="impactAssessment.altitudeInterval.feets"/>
                    <span>[ft]</span>

                    <input name="altitudeIncrementMeters" type="number" style="width: 30%"
                           [min]="singleLevelInput.checked ? 0 : 30.38 " max="18288"
                           [(ngModel)]="impactAssessment.altitudeInterval.meters"/>
                    <span>[m]</span>
                  </div>
                  <span class="error" *ngIf="altitudeIncrementFeet.invalid">
                      The Altitude Increment value should be between 100 and 60000 ft or 30.48 and 18288 m.
                  </span>
                  <span class="error"
                        *ngIf="impactAssessment.maxAltitude.feets-impactAssessment.minAltitude.feets < impactAssessment.altitudeInterval.feets">
                      The Altitude Increment value should be smaller than Max Altitude - Min Altitude.
                  </span>
                </div>
              </div>
            </fieldset>
            <div class="fields__block__section" *ngIf="devices != null">
              <div class="title">
                <h4 style="width: auto;">RFI-Transmitter</h4>
                <span style="width: 90%;"> </span>
              </div>

              <ng-container *ngIf="devices.length > 0; else empty">
                <app-grit-dynamic-table-features
                  [mode]="GritDynamicTableMode.SELECT_MULTIPLE"
                  [type]="GritDynamicTableType.BASIC"
                  [pageSize]="5"
                  [features]="devices"
                  [selectAll]="selectAll">
                </app-grit-dynamic-table-features>
              </ng-container>
              <ng-template #empty>
                <p style="color: crimson;">Create at least one RFI-Transmitter in the map</p>
              </ng-template>

            </div>

            <div class="fields__block__section">
              <div class="title">
                <h4 style="width: auto;">Receivers</h4>
                <span style="width: 90%;"> </span>
              </div>

              <app-grit-dynamic-table
                [mode]="GritDynamicTableMode.VIEW"
                [type]="GritDynamicTableType.BASIC"
                [pageSize]="5"
                [entityName]="'Receivers'"
                [tableConfiguration]="ReceiverModel.configuration.table"
                [models]="receivers">
              </app-grit-dynamic-table>
            </div>
          </div>

          <div class="fields__btn">
            <button type="submit" class="blue" (click)="ok()" #okButton
            [disabled]="table?.selectedFeatures.length == 0 || devices?.length == 0 || receivers.length == 0 || !ngForm.form.valid"
            [ngClass]="!okButton.disabled ? 'blue' : 'gray'">Ok</button>
            <button class="gray" type="reset" (click)="cancel()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
